import React, { useState, useRef } from "react";
import SearchImg from "assets/icons/search.svg";
import "./style.scss";

type Props = {
	keyword: string,
	onSearch: (val: string) => void;
  showAdvanceSearch: () => void;
};

export const SearchBar: React.FC<Props> = ({
	keyword,
	onSearch,
  showAdvanceSearch,
}) => {
  const [className, setClassName] = useState('searchbar');
  
  const handleInputFocus = (e) => {
    setClassName('searchbar searchbar-focus');
  }

  const handleInputBlur= (e) => {
    setClassName('searchbar');
  }

  return (
    <div className="searchbar-container">
      <span className="searchbar-title">Customer Search</span>
      <div className={className}>
        <img src={SearchImg} alt="sort" />
        <input
          value={keyword}
          type="text"
          onChange={(e) => onSearch(e.target.value)}
          onBlur={handleInputBlur}
          onFocus={handleInputFocus}
          placeholder="Search Customer"
        ></input>
        <span onClick={() => showAdvanceSearch()}>Advance search</span>
      </div>
    </div>
  );
};
